module.exports = __webpack_public_path__ + "assets/643a5794f061cf2ec324a074a749e717.png";